import React from "react";
import ScrambleText from "@/components/ScrambleText";

/**
 * Standard Vibecity section heading. Renders as:
 *   { LINE_A           }
 *   { LINE_B (gradient)}
 * Wrapped in tall curly braces. LINE_B gets the section accent gradient
 * (alternates green/yellow ↔ blue per page rhythm).
 *
 * On scroll-into-view each letter cycles FT Activica
 * Pixel/Strong/Normal/Symbols in random order before settling on FT Activica
 * Mix (~400ms total).
 */
const GREEN_GRADIENT =
    "linear-gradient(180deg, #90FDA6 0%, #F8FF28 100%)";
const BLUE_GRADIENT =
    "linear-gradient(177.93deg, #07E6F6 40.24%, #003C9D 127.8%)";

export default function SectionHeading({
    lineA,
    lineB,
    accent = "green", // "green" | "blue"
    testId,
    className = "",
    subtitle,
}) {
    const gradient = accent === "blue" ? BLUE_GRADIENT : GREEN_GRADIENT;
    return (
        <div
            className={`mx-auto mb-20 md:mb-24 w-full max-w-5xl flex flex-col items-center ${className}`}
            style={{ margin: "0 auto 5rem auto" }}
        >
            <h2
                data-testid={testId}
                className="w-full flex items-center justify-center gap-3 md:gap-5"
            >
                <span
                    aria-hidden
                    className="text-[#FFFCE1] leading-none select-none"
                    style={{
                        fontSize: "clamp(3.5rem, 11vw, 10.5rem)",
                        fontFamily:
                            '"FT Activica Normal", "FT Activica Strong", sans-serif',
                        fontWeight: 300,
                    }}
                >
                    {"{"}
                </span>
                <div
                    className="flex flex-col items-center text-center leading-[1.05]"
                    style={{ fontWeight: 400 }}
                >
                    <ScrambleText
                        text={lineA}
                        className="text-[#FFFCE1] uppercase block"
                        style={{
                            fontSize: "clamp(1.7rem, 5.2vw, 4.6rem)",
                            letterSpacing: "0.04em",
                        }}
                    />
                    <ScrambleText
                        text={lineB}
                        className="uppercase block"
                        style={{
                            fontSize: "clamp(1.7rem, 5.2vw, 4.6rem)",
                            letterSpacing: "0.04em",
                            background: gradient,
                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            color: "transparent",
                        }}
                    />
                </div>
                <span
                    aria-hidden
                    className="text-[#FFFCE1] leading-none select-none"
                    style={{
                        fontSize: "clamp(3.5rem, 11vw, 10.5rem)",
                        fontFamily:
                            '"FT Activica Normal", "FT Activica Strong", sans-serif',
                        fontWeight: 300,
                    }}
                >
                    {"}"}
                </span>
            </h2>
            {subtitle && (
                <p
                    data-testid={testId ? `${testId}-subtitle` : undefined}
                    className="text-center mt-6 md:mt-8 px-4"
                    style={{
                        fontFamily:
                            '"Figtree", "Inter", system-ui, sans-serif',
                        fontWeight: 500,
                        fontSize: "clamp(16px, 1.4vw, 22px)",
                        lineHeight: 1.35,
                        letterSpacing: "0.005em",
                        color: "#9A9A92",
                        maxWidth: "44rem",
                    }}
                >
                    {subtitle}
                </p>
            )}
        </div>
    );
}

export const DIN_STACK =
    '"Figtree", "Inter", system-ui, sans-serif';
